module.exports = __webpack_public_path__ + "img/hometh2.763b5089.png";